import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Heading, IconChat, NamedLink } from '../../components';
import ShareModal from '../../components/ShareModal/ShareModal';

import css from './ListingPage.module.css';

const SectionProviderLocation = props => {
  const {
    providerName,
    providerProfile,
    address,
    onContactClick,
    listing,
    onManageDisableScrolling = () => {},
  } = props;

  const providerType = providerProfile?.publicData?.userType;
  const memberships = {
    verified: providerProfile?.publicData?.membershipsVerified,
    items: providerProfile?.publicData?.memberships,
  };
  const showMemberships = memberships?.verified && memberships?.items?.length > 0;
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  return (
    <div className={css.providerLocationSection}>
      <div className={classNames(css.providerLocationColumn, css.providerColumn)}>
        <div className={css.providerLocationTitle}>
          <FormattedMessage id="SectionProvider.title" />
        </div>
        <Heading as="h3" rootClassName={css.providerName}>
          {listing?.author?.id?.uuid && providerType === 'businessSeller' ? (
            <NamedLink
              className={css.providerNameLink}
              name="ProfilePage"
              params={{ id: listing.author.id.uuid }}
            >
              {providerName}
            </NamedLink>
          ) : (
            providerName
          )}
        </Heading>
        <div className={css.providerValue}>
          <FormattedMessage
            id={
              providerType === 'businessSeller'
                ? 'SectionProvider.typeProfessional'
                : 'SectionProvider.typePrivate'
            }
          />
        </div>
        {showMemberships ? (
          <div className={css.providerValue}>
            <FormattedMessage
              id="SectionProvider.membership"
              values={{ memberships: memberships.items.join(', ') }}
            />
          </div>
        ) : null}
        <button
          type="button"
          className={classNames(css.providerContactLink, css.providerContactLinkDesktop)}
          onClick={onContactClick}
        >
          <FormattedMessage id="SectionProvider.contactLink" />
        </button>
        <button
          type="button"
          className={classNames(css.providerContactLink, css.providerContactLinkMobile)}
          onClick={onContactClick}
        >
          <IconChat className={css.providerContactIcon} />
          <FormattedMessage id="SectionProvider.contactLink" />
        </button>
      </div>

      <div className={classNames(css.providerLocationColumn, css.locationColumn)}>
        <div className={css.locationRow}>
          <span className={css.listingItemLocation}>
            <FormattedMessage id="SectionProvider.locationTitle" />
          </span>
          <span className={css.providerValue}>{address}</span>
        </div>
      </div>

      <div className={classNames(css.providerLocationColumn, css.providerActionsColumn)}>
        <button
          type="button"
          className={css.providerActionLink}
          onClick={() => setIsShareModalOpen(true)}
        >
          <FormattedMessage id="SectionProvider.share" />
        </button>
      </div>

      <ShareModal
        isOpen={isShareModalOpen}
        onCloseModal={e => {
          e.stopPropagation();
          setIsShareModalOpen(false);
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        listing={listing}
      />
    </div>
  );
};

export default SectionProviderLocation;
